import { useMemo } from 'react';
import { useAopTopBarFlag } from 'hooks/useFeatureFlag';
import { toggleUseAopTopbar } from 'microFrontend/slices/aopUserConfig.slice';
import { selectUserIsRoot } from 'slices/auth.slice';
import { useAppDispatch, useAppSelector } from 'slices/store';
import { Icon } from '@timeedit/ui-components';
import { MenuProps } from '@timeedit/ui-components/antd/menu/menu';

export function useAopUserMenu(): MenuProps {
  const isRoot = useAppSelector(selectUserIsRoot);
  const dispatch = useAppDispatch();
  const flagValue = useAopTopBarFlag();

  return useMemo(() => {
    if (flagValue !== 'rootOptIn' || (!isRoot && !import.meta.env.DEV)) {
      return undefined;
    }
    return {
      onClick: (e) => {
        if (e.key === 'toggle-aop') {
          dispatch(toggleUseAopTopbar());
        }
      },
      items: [
        {
          key: 'toggle-aop',
          label: 'Toggle experimental AOP navigation',
          icon: <Icon id="ReloadOutlined" alt="" />,
        },
      ],
    };
  }, [isRoot, dispatch, flagValue]);
}
